import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import FeedbackDetail from "./feedbackDetail";
import {
    getFeedbackById,
} from "services/redux/brandActivtion/meetings/action";

const mapStateToProps = (state) => ({
    feedbackById: state.baMeetingReducer.feedbackById,
    cancel: state.baMeetingReducer.cancel,
    complete: state.baMeetingReducer.complete,

});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getFeedbackById,
           
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackDetail);
